























































































import Vue from "vue";
//import PremiumBtn from "@/components/premium/PremiumBtn.vue";
import LevelLabel from "@/components/LevelLabel.vue";
import Spinner from "@/components/Spinner.vue";
import { computed } from "@vue/composition-api";
import { InfoTypeExposure } from "./data/models";
import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";

export default Vue.extend({
  props: ["card", "isLoading", "premium", "label_icon"],
  components: {
    //    PremiumBtn,
    LevelLabel,
    //  Spinner,
    SkeletonLoaderItem,
  },
  setup(props, { emit }) {
    const disable = computed(() => {
      // @ts-ignore
      const { high, medium, low } = props.card;
      return [high, medium, low].every((val) => val == 0);
    });
    const count = computed(() => {
      const { high = 0, medium = 0, low = 0 } = props.card as InfoTypeExposure;
      return high + medium + low;
    });

    const go = () => {
      if (!disable.value) {
        emit("go");
      }
    };
    return {
      disable,
      count,
      go,
    };
  },
});
